import React, { useState } from 'react';
import ReactDOM from "react-dom";
import JobOrderDeliveryDataTable from "../../datatables/JobOrderDeliveryDataTable";
import JobOrderDeliveryCreateEditPage from "../JobOrderDeliveryCreateEditPage";

export const DELIVERY_PAGES = {
    INDEX:  'index',
    CREATE: 'create',
    EDIT:   'edit',
}

const JobOrderDeliveryPage = (props) => {
    const {
        jobId       = null,
        orderId     = null,
        deliveryId  = null,
        page        = DELIVERY_PAGES.INDEX,
        parentId    = "",
    } = props;


    const [currentPage, setCurrentPage]             = useState(page);
    const [selectedDelivery, setSelectedDelivery]   = useState(!!deliveryId ? {id: deliveryId} : null);

    const handleChangePage = (page, delivery) => {
        switch (page) {
            case DELIVERY_PAGES.INDEX:
                window.history.pushState({}, '', route('job.order.delivery.index', {job: jobId, order: orderId}).toString());
                break;
            case DELIVERY_PAGES.CREATE:
                window.history.pushState({}, '', route('job.order.delivery.create', {job: jobId, order: orderId}).toString());
                break;
            case DELIVERY_PAGES.EDIT:
                window.history.pushState({}, '', route('job.order.delivery.edit', {job: jobId, order: orderId, delivery: delivery.id}).toString());
                break;
        }

        setCurrentPage(page);
        setSelectedDelivery(delivery);
    }

    switch (currentPage) {
        case DELIVERY_PAGES.EDIT:
            return (
                <JobOrderDeliveryCreateEditPage
                    jobId={jobId}
                    orderId={orderId}
                    deliveryId={!!selectedDelivery && !!selectedDelivery.id ? selectedDelivery.id : null}
                    onChangePage={(page, delivery) => handleChangePage(page, delivery)}
                    parentId={parentId}
                />
            );
        case DELIVERY_PAGES.CREATE:
            return (
                <JobOrderDeliveryCreateEditPage
                    jobId={jobId}
                    orderId={orderId}
                    deliveryId={null}
                    onChangePage={(page, delivery) => handleChangePage(page, delivery)}
                    parentId={parentId}
                />
            );
        case DELIVERY_PAGES.INDEX:
        default:
            return (
                <JobOrderDeliveryDataTable
                    jobId={jobId}
                    orderId={orderId}
                    onChangePage={(page, delivery) => handleChangePage(page, delivery)}
                    parentId={parentId}
                />
            );
    }
}

export default JobOrderDeliveryPage;

const target = document.getElementById('job-order-delivery-page');
if (target) {
    const {
        jobId       = null,
        orderId     = null,
        deliveryId  = null,
        page        = DELIVERY_PAGES.INDEX,
        parentId    = 'job-order-delivery-page'
    } = target.dataset;

    ReactDOM.render(
        <JobOrderDeliveryPage
            jobId={jobId}
            orderId={orderId}
            deliveryId={deliveryId}
            page={page}
            parentId={parentId}
        />
    , target);
}

